<script setup lang="ts">
defineProps<{
    title?: string
    description?: string
    newTag?: boolean
    negativeTag?: boolean
}>()

const { t } = useI18n()
</script>

<template>
    <div
        class="flex flex-col gap-1 screen-ratio-[2]:!mb-0 lg:mb-4 xl:max-w-4xl"
    >
        <h1
            v-if="title"
            class="mb-2 flex gap-2 font-rubik text-xl font-bold uppercase xl:screen-ratio-[2]:mb-0 xl:screen-ratio-[2]:text-lg"
        >
            <UiTag
                v-if="newTag"
                class="self-center bg-sun-yellow/50 text-sun-yellow"
            >
                {{ t('new') }}
            </UiTag>

            <UiTag
                v-if="negativeTag"
                class="self-center bg-earth-red/50 text-earth-red"
            >
                {{ t('negative') }}
            </UiTag>

            <slot name="title" :title="title">
                {{ title }}
            </slot>
        </h1>
        <p
            v-if="description"
            class="font-sans text-xs xl:text-sm xl:screen-ratio-[2]:text-xs"
        >
            {{ description }}
        </p>
    </div>
</template>